'use client'

import classNames from 'classnames'
import { useEffect, useState } from 'react'
import SubnavDefaultSection from './SubnavDefaultSection'
import SubnavPanelSection from './SubnavPanelSection'
import Accordion from './Accordion'
import { useActiveNav } from '../context/ActiveNavContext'

const Close = ({ size = 24, color = '#1C274C', strokeWidth = 2 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 18L18 6M6 6L18 18"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const NavigationItems = ({ navigationItems, expanded, handleChange }) => {
  const { isActive, isActiveBranch } = useActiveNav()
  const componentMap = []

  for (const item of navigationItems) {
    const Component =
      item.variant === 'list' ? SubnavDefaultSection : SubnavPanelSection
    const hasChildren = item?.children?.length > 0

    componentMap.push(
      <Accordion
        key={item.id}
        id={item.id}
        expanded={expanded === item.id}
        onChange={handleChange}
        label={item.label}
        href={!hasChildren ? item.link : undefined}
        ariaCurrent={!hasChildren && isActive(item) ? 'page' : undefined}
        summaryClassName={classNames(
          isActiveBranch(item) ? 'text-blue-base' : 'text-[#1d252f]'
        )}
      >
        {hasChildren ? <Component data={item} isMobile={true} /> : null}
      </Accordion>
    )
  }

  return <div className="flex w-full flex-col gap-2">{componentMap}</div>
}

export const Sidebar = ({
  iconHeader,
  open,
  handleClose,
  bottomCtas,
  navigationItems,
}) => {
  const [expanded, setExpanded] = useState(null)

  const handleChange = (newId) => {
    setExpanded((prev) => (prev === newId ? null : newId))
  }

  useEffect(() => {
    if (typeof document === 'undefined') return undefined

    if (open) {
      const previousOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'

      return () => {
        document.body.style.overflow = previousOverflow
      }
    }

    return undefined
  }, [open])

  return (
    <div
      data-testid="mega-menu-sidebar"
      className={classNames(
        'fixed top-0 left-0 z-100 flex h-screen w-0 flex-col overflow-hidden bg-white px-0 py-2 transition-all duration-300 ease-in-out',
        { 'w-screen!': open }
      )}
    >
      {open && (
        <>
          <div className="mt-4 flex w-full shrink-0 flex-row items-center justify-between gap-2 border-0 border-b-2 border-solid border-gray-200 px-4 pb-4">
            {iconHeader}
            <button
              onClick={handleClose}
              className="border-none bg-transparent"
            >
              <Close />
            </button>
          </div>
          <div className="flex w-full flex-1 flex-col gap-2 overflow-y-auto overscroll-contain">
            <NavigationItems
              navigationItems={navigationItems}
              expanded={expanded}
              handleChange={handleChange}
            />
          </div>
          <div className="flex w-full shrink-0 flex-col gap-2 px-4 pt-2">
            {bottomCtas}
          </div>
        </>
      )}
    </div>
  )
}

export default Sidebar
